const GenerateUUID = () => {
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });

    return uuid;
}

const toTitleCase = (str) => {
    if (!str) return '';
    return str.replace(/\w\S*/g, (txt) =>
        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
};

const getDisplayAmount = (amount) => {
    if (!amount || parseFloat(amount) === 0) {
        return '--';
    }
    return amount;
};

const formatMillisecondsTohours = (milliseconds = 0) => {
   if (!milliseconds || milliseconds < 0) return "0s";
  const totalSeconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours === 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${hours}h ${minutes}m`;
};

const resolveRecordFiles = (filesWithMetadata, defaultName = "CV File") => {
    return filesWithMetadata?.map((f, index) => ({
        file: f.file,
        name: f.originalFileName || f.name || `${defaultName} ${index + 1}`,
    })) || [];
}

export { GenerateUUID, toTitleCase, getDisplayAmount, formatMillisecondsTohours, resolveRecordFiles };
